import {
  Box,
  Heading,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Text,
} from '@chakra-ui/react'
import { Strata } from './Strata'
import { FAQ_ITEMS } from './faq-data'

export const FaqSection = () => (
  <Strata tone="canvas">
    <Heading size="lg" mb={8} textAlign="center">
      Frequently asked questions
    </Heading>
    <Accordion allowToggle>
      {FAQ_ITEMS.map(item => (
        <AccordionItem key={item.question} borderColor="line.dark">
          <AccordionButton _hover={{ bg: 'bg.band' }} py={4}>
            <Box flex="1" textAlign="left" fontFamily="heading" fontSize="lg" color="text.engraved">
              {item.question}
            </Box>
            <AccordionIcon color="brand.gold" />
          </AccordionButton>
          <AccordionPanel pb={4}>
            <Text color="text.muted">{item.answer}</Text>
          </AccordionPanel>
        </AccordionItem>
      ))}
    </Accordion>
  </Strata>
)

export default FaqSection
